import clsx from 'clsx';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

// Components
import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

// Routes
import { DASHBOARD_VIEW } from '@/routes/privateRoutes';

// Types
import type { DashboardType } from '@/types/dashboardType';

type SuccessModalProps = {
    title?: string;
    notice: string;
    isOpen: boolean;
    toggle: () => void;
    buttonText: string;
    dashboardId?: DashboardType['id'];
};

export const SuccessModal = ({
    title,
    notice,
    isOpen,
    toggle,
    buttonText,
    dashboardId = null
}: SuccessModalProps) => {
    const { t } = useTranslation('dashboard');
    const router = useRouter();

    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <Modal.Body>
                <Modal.Title>{title ?? t('commons:success')}</Modal.Title>
                <Modal.Content className="pt-8 text-center text-sm">{notice}</Modal.Content>
                <Modal.Footer
                    className={clsx('mt-8 flex items-center px-5 pb-12 sm:px-12', {
                        'justify-center': !dashboardId,
                        'justify-between': dashboardId
                    })}>
                    {dashboardId ? (
                        <button
                            type="button"
                            onClick={toggle}
                            className="font-GSemiBold text-xs text-icoGray-500 underline dark:text-icoDarkMode-wolf">
                            {t('commons:close')}
                        </button>
                    ) : null}
                    <Button
                        onClick={() => {
                            if (dashboardId) {
                                router.push(DASHBOARD_VIEW.replace('[id]', dashboardId.toString()));
                            } else {
                                toggle();
                            }
                        }}>
                        {buttonText}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};
